export const appVersion = 1.0;
export const twitterTokenName = "twitter-clone-token";
export const defaultPageSize = 35